
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands, getDateRange } from "@common/src/utils/common";
import dayjs from "dayjs";
import { Table, TableRowsSelect, InjectFunction } from "@common/src/utils/decorator";
import { formDownload } from "@common/src/utils/tools";
import t from "@common/src/i18n/t";
import appCode from "@common/src/utils/app-code";
import { addCurrencyUnit } from "@common/src/utils/tools";
import { OpDefalutQueryStore } from "@common/src/utils/constant";

const statement = namespace("statement");
const base = namespace("base");
const management = namespace("management");
const parts = namespace("parts");

@InjectFunction("permitApp")
@Component({})
@Table("loadListData")
export default class Statement extends Vue {
  @statement.Action queryTireSalesReport;
  @base.Action getDictionaryList;
  @management.Action getStoreList;
  @parts.Action getPartsList;
  addCurrencyUnit = addCurrencyUnit;
  dayjs = dayjs;
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  searchForm: any = {
    storeCode: "", // 门店名称
    area: "", // 所在地区
    stateName: "", // 省级名称
    cityName: "", // 市级名称
    districtName: "", // 县级名称
    statisticMethod: "1", // 时间范围类型, 1-按日,2-按月
    beginDate: "", // 开始时间 格式: 按日为yyyyMMdd, 按月为yyyyMM
    endDate: "", // 结束时间 格式: 按日为yyyyMMdd, 按月为yyyyMM
    partsCode: ""
  };
  contentList: any = [];
  dataLastUpdateTime: any = "";

  created() {
    if (this.permitApp("speedbiz-operation")) {
      this.searchForm.storeCode = OpDefalutQueryStore.value;
    }
    this.init();
  }
  toStatementView(row) {
    if (row) {
      const dateFormat = row.date.replace(/-/g, "");
      this.$router.push({
        name: "statementMarketView",
        params: {
          fromList: "1",
          ...this.searchForm,
          beginDate: dateFormat,
          endDate: dateFormat
        }
      });
    } else {
      this.$router.push({
        name: "statementMarketView",
        params: {
          fromList: "1",
          ...this.searchForm
        }
      });
    }
  }
  storeList: any = [OpDefalutQueryStore];
  selfData: any = [];
  get searchList() {
    return [
      {
        label: t("v216_6.statistical-dimension"),
        type: "btn-radio",
        prop: "statisticMethod",
        options: this.dateTypeOptions,
        value: this.searchForm.statisticMethod,
        typeChangeMethod: this.handleDateTypeChange,
        required: true
      },

      {
        if: this.searchForm.statisticMethod === "1",
        label: t("v210831.time-frame"),
        value: [this.searchForm.beginDate, this.searchForm.endDate],
        resetValue: this.getDefaultDate("1"),
        type: "daterange",
        prop: "date",
        required: true,
        disabledFuture: true,
        maxDay: 90,
        valueDistribute: ["beginDate", "endDate"]
      },
      {
        if: this.searchForm.statisticMethod === "2",
        label: t("v210831.time-frame"),
        value: [this.searchForm.beginDate, this.searchForm.endDate],
        resetValue: this.getDefaultDate("2"),
        type: "monthrange",
        prop: "month",
        required: true,
        disabledFuture: true,
        maxMonth: 12,
        valueDistribute: ["beginDate", "endDate"]
      },
      {
        if: appCode === "speedbiz",
        label: t("parts.text"),
        type: "select-search",
        value: "",
        prop: "partsCode",
        selectList: this.partsList,
        searchFun: this.searchParts
      },
      {
        if: appCode === "speedbiz-operation",
        label: t("staff.store"),
        type: "select-search",
        value: OpDefalutQueryStore.value,
        prop: "storeCode",
        selectList: this.storeList,
        searchFun: this.searchStore,
        clearable: false
      },
      {
        if: appCode === "speedbiz-operation",
        label: t("setting.region"),
        type: "area",
        value: "",
        labels: [],
        prop: "area",
        anyLevel: true,
        valueDistribute: ["stateName", "cityName", "districtName"]
      }
    ].filter(item => item.if !== false);
  }
  searchStore(val = "") {
    this.getStoreList({
      pageNum: 1,
      pageSize: 10,
      storeName: val
    }).then(data => {
      this.storeList = (data.data?.list || []).map(item => {
        item.label = item.storeName;
        item.value = item.storeCode;
        return item;
      });
    });
  }
  init() {
    if (appCode === "speedbiz") {
      this.searchForm.storeCode = "";
    } else if (appCode === "speedbiz-operation") {
      this.searchStore("");
    }
    this.handleDateTypeChange(this.searchForm.statisticMethod);
    this.searchParts();
    this.loadListData();
  }
  handleExportData() {
    formDownload(`${window.API_URL}/report/v2/exportTireSalesReport`, this.searchForm);
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryTireSalesReport({
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      if (data.data.dataLastUpdateTime) {
        this.dataLastUpdateTime = data.data.dataLastUpdateTime;
      }
      this.contentList = data.data.list;
      return data;
    });
  }
  @TableRowsSelect.updateMethod
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.valueAlias || item.prop] = item.value;
      }
    });
    if (this.permitApp("speedbiz-operation") && !this.searchForm.storeCode) {
      return this.$message.error(t("v210831.please-select-a-store"));
    }
    this.loadListData();
  }
  partsList = [];
  searchParts(val = "") {
    this.getPartsList({
      status: "1",
      pageNum: 1,
      pageSize: 10,
      partsName: val
    }).then(data => {
      this.partsList = (data.data?.list || []).map(item => {
        item.label = item.partsName;
        item.value = item.partsCode;
        return item;
      });
    });
  }
  dateTypeOptions = [
    { label: t("sb_copy.query-by-day"), value: "1" },
    { label: t("sb_copy.query-by-month"), value: "2" }
  ];
  handleDateTypeChange(val) {
    [this.searchForm.beginDate, this.searchForm.endDate] = this.getDefaultDate(val);
    this.searchForm.statisticMethod = val;
  }
  getDefaultDate(type: "1" | "2"): Array<string> {
    if (type === "1") {
      return getDateRange("first_day_to_today_of_current_month", "YYYYMMDD");
    } else if (type === "2") {
      return getDateRange("first_month_to_current_month_of_current_year", "YYYYMM");
    } else {
      return [];
    }
  }
}
